// Slick Slider
export const initSlider = () => {
    $('.slick-wrapper').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 10000,
        speed: 300,
    });

    $('.slider-nav').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: true,
        dots: false,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 10000,
        speed: 300,
        responsive: [
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1.4,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.2,
                }
            },
            {
                breakpoint: 430,
                settings: {
                    slidesToShow: 1.1,
                }
            },
        ]
    });

    const activeSlideDown = () => {
        const activeSlide = $(".slick-active");
        $(activeSlide).parent().parent().prev('.slick-slide').children().children().addClass('slick-active');
        $(activeSlide).removeClass('active');
    }

    const activeSlideUp = () => {
        const activeSlide = $(".slick-active");
        $(activeSlide).parent().parent().next('.slick-slide').children().children().addClass('slick-active');
        $(activeSlide).removeClass('active');
    }

    $('.slick-prev').click(() => {
        activeSlideDown();
    })

    $('.slick-next').click(() => {
        activeSlideUp();
    })
}

